import { jsx as _jsx } from "react/jsx-runtime";
import { useRef, useEffect } from "react";
import styles from "./OtpInput.module.css";
export const OtpInput = ({ fields, onChange, onPaste, onComplete, }) => {
    const inputRefs = useRef([]);
    useEffect(() => {
        inputRefs.current[0]?.focus();
    }, []);
    const handleInput = (index, value) => {
        // Only allow single digit
        if (value && !/^\d$/.test(value)) {
            return;
        }
        onChange(index, value);
        // Auto-focus next input after entering a digit
        if (value && index < fields.length - 1) {
            inputRefs.current[index + 1]?.focus();
        }
        // Trigger onComplete when last field is filled
        if (value && index === fields.length - 1) {
            const updatedFields = [...fields];
            updatedFields[index] = value;
            setTimeout(() => onComplete?.(updatedFields), 0);
        }
    };
    const handleKeyDown = (index, e) => {
        if (e.key === "Backspace") {
            if (fields[index] === "") {
                // If current field is empty, go to previous field
                if (index > 0) {
                    inputRefs.current[index - 1]?.focus();
                }
            }
            else {
                // If current field has value, clear it (default behavior)
                // The onChange will handle clearing the value
            }
        }
    };
    const handleFocus = (e) => {
        // Select the input value on focus for easy replacement
        e.target.select();
    };
    const handlePaste = (e) => {
        e.preventDefault();
        const paste = e.clipboardData.getData("text").replace(/\D/g, "");
        if (!paste)
            return;
        const digits = paste.split("").slice(0, fields.length);
        // Create filled fields array
        const filledFields = Array(fields.length).fill("");
        digits.forEach((digit, i) => {
            filledFields[i] = digit;
        });
        if (onPaste) {
            onPaste(filledFields);
        }
        else {
            // Fallback: update one by one
            digits.forEach((digit, i) => {
                onChange(i, digit);
            });
        }
        const lastFilledIndex = Math.min(digits.length - 1, fields.length - 1);
        inputRefs.current[lastFilledIndex]?.focus();
        if (digits.length >= fields.length) {
            setTimeout(() => onComplete?.(filledFields), 0);
        }
    };
    return (_jsx("div", { className: styles.otpBox, children: fields.map((value, index) => (_jsx("input", { ref: (el) => (inputRefs.current[index] = el), type: "text", inputMode: "numeric", pattern: "[0-9]*", maxLength: 1, className: styles.otpInput, value: value, onChange: (e) => handleInput(index, e.target.value), onKeyDown: (e) => handleKeyDown(index, e), onFocus: handleFocus, onPaste: handlePaste, autoComplete: "one-time-code" }, index))) }));
};
